import { FC } from 'react';
import { ProductGridStoryblok } from 'storyblok-types';
import { IStoryBlokComponentProps } from 'pages/StoryBlok/types';
import { getCategoryByPath } from 'commerce/scayle/product-management';
import { getPageBanners } from 'commerce/services/banner';
import { getCategoryProductsBackend } from 'commerce/shop/backend';
import { ClientPageType } from 'src/app/types';
import { ProductsGrid } from './ProductsGrid';

export const View2: FC<
  IStoryBlokComponentProps<ProductGridStoryblok>
> = async ({ blok }) => {
  const { categorySlug, title, searchQuery } = blok;
  const { response: category } = await getCategoryByPath(
    categorySlug as string,
  );

  if (!category?.id) {
    return null;
  }

  const [productsResp, bannersResp] = await Promise.all([
    getCategoryProductsBackend({
      categoryName: category.name,
      searchQuery: new URLSearchParams(searchQuery),
    }),
    getPageBanners({
      idx: Number(blok.bannerPageIndex || 0),
      slug: ClientPageType.HOME,
    }),
  ]);

  const products = productsResp.data?.hits;
  const banners = bannersResp.response || [];

  if (!products?.length) {
    return null;
  }

  return <ProductsGrid title={title} products={products} banners={banners} />;
};
